/**
 * @file Tag 可关闭标签
 * @description 筛选条件等可移除标签。
 *
 * @whenToUse 已选筛选、附件名标签。
 * @whenNotToUse 只读状态色（用 Badge）。
 */

import type { HTMLAttributes, ReactNode } from 'react'
import { X } from 'lucide-react'
import { cn } from '@/lib/cn.ts'

export type TagProps = HTMLAttributes<HTMLSpanElement> & {
  /** 关闭回调；传入则显示关闭按钮 */
  onClose?: () => void
  children: ReactNode
}

export function Tag({ className, children, onClose, ...rest }: TagProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-md border border-border bg-raised px-2 py-0.5 text-xs text-foreground',
        className,
      )}
      {...rest}
    >
      {children}
      {onClose ? (
        <button
          type="button"
          aria-label="移除"
          className="inline-flex text-muted transition-opacity duration-200 hover:opacity-90"
          onClick={onClose}
        >
          <X className="size-3" aria-hidden />
        </button>
      ) : null}
    </span>
  )
}
